/* eslint-disable */
import MobxReactForm from 'mobx-react-form';
import dvr from 'mobx-react-form/lib/validators/DVR';
import validatorjs from 'validatorjs';
import { PHONE_PREFIXES, PHONE_PREFIX_DEFAULT } from 'framework/constants/forms';
export const fields = [
    {
        name: 'email',
        label: 'ContactPage:email',
        rules: 'required|email',
        value: ''
        // disabled: true
    },
    {
        name: 'phoneMain',
        label: 'ContactPage:phone',
        rules: 'required',
        default: PHONE_PREFIX_DEFAULT.value,
        fields: [
            {
                name: 'countryCode',
                placeholder: 'countryCode',
                extra: PHONE_PREFIXES,
                value: PHONE_PREFIX_DEFAULT,
                rules: 'required',
                output: (data) => {
                    return data.value ? data.value : data;
                },
                default: PHONE_PREFIX_DEFAULT.value
            },
            {
                name: 'areaCode',
                label: 'areaCode',
                type: 'tel',
                rules: 'required|phone_areaCode',
                default: ''
            },
            {
                name: 'phoneNumber',
                label: 'phone',
                type: 'tel',
                rules: 'required|phone_phoneNumber',
                default: ''
            }
        ],
        output: (value) => {
            const { countryCode, areaCode, phoneNumber } = value;
            return `${countryCode ? countryCode : ''}${areaCode}${phoneNumber}`;
        }
    },
    {
        name: 'callBackRequest',
        label: 'ContactPage:time',
        rules: 'required',
        value: null
    },
    {
        name: 'time',
        label: 'ContactPage:time',
        value: 0,
        default: 0
    },
    {
        name: 'day',
        label: 'ContactPage:day',
        value: 0,
        default: 0
    },
    {
        name: 'message',
        label: 'ContactPage:message',
        rules: 'required',
        type: 'string',
        default: ''
    }
];
const hooks = {
    onSuccess(form) { },
    onError(form) {
        console.log('qqq Form errors ====', form.errors());
    }
};
const plugins = {
    dvr: dvr({
        package: validatorjs
    })
};
const options = {
    validateOnChange: true
};
export default new MobxReactForm({ fields }, { plugins, hooks, options });
/* eslint-enable */
